(function($) {
	function blockquote() {
		var pageWidth = $('.blogSingle').outerWidth();
		var blockWidth = $('.content').outerWidth();
		var left = -(pageWidth - blockWidth)/2;
		$('blockquote').css('width', pageWidth+'px');
		$('blockquote').css('left', left+'px');
		$('blockquote p').css('max-width', blockWidth+'px');
	}
	
	$(document).ready(function () {
		blockquote();
	});
	$(window).resize(function(){
		blockquote();
	});

})(jQuery);